import React from 'react';
import Card from 'material-ui/Card';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

const Dashboard = ({ realtors }) => {
  console.log(realtors);
  return (
    <Card style={{ marginTop: 30, padding: 12, borderRadius: 10 }}>
    <h3> Statistics </h3>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Name</TableHeaderColumn>
          <TableHeaderColumn>Minutes Remaining</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {
          Object.keys(realtors).map(realtor => {
            return (
            <TableRow>
              <TableRowColumn>
                {realtor}
              </TableRowColumn>
              <TableRowColumn>
                {realtors[realtor]}
              </TableRowColumn>
            </TableRow>)
          })
        }
      </TableBody>
    </Table>
    </Card>
  )
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx